/**
 * Composition Tools Store
 *
 * Manages state for the composition tools panel (Voice Lines).
 */

import { create } from 'zustand';

type ToolsTab = 'voices';

// isPanelOpen lives in modal-store under key 'compositionTools'

interface CompositionToolsState {
  activeTab: ToolsTab;
}

interface CompositionToolsActions {
  setActiveTab: (tab: ToolsTab) => void;
}

export const useCompositionToolsStore = create<CompositionToolsState & CompositionToolsActions>(
  (set) => ({
    activeTab: 'voices',

    setActiveTab: (tab) => {
      set({ activeTab: tab });
    },
  })
);
